module.exports = __webpack_public_path__ + "static/img/sp_3.6103c14.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/sports/sp_3.png
// module id = 833
// module chunks = 1